<i18n>
{
  "br": {
    "email": "Email",
    "phone": "Telefone",
    "idNumber": "CPF"
  },
  "cl": {
    "email": "Email",
    "phone": "Teléfono",
    "idNumber": "Rut"
  },
  "pe": {
    "email": "Email",
    "phone": "Teléfono",
    "idNumber": "DNI/CE"
  }
}
</i18n>

<template>
  <div
    id="prospect-contact-data"
    class="med-size-text columns">
    <div class="prospect-id-number column">
      <strong>{{ $t("idNumber") }}</strong><br>
      <span>{{ prospect.idNumber }}</span>
    </div>
    <div class="prospect-email column">
      <strong>{{ $t("email") }}</strong><br>
      <span>{{ prospect.email }}</span>
    </div>
    <div class="prospect-phone column">
      <strong>{{ $t("phone") }} </strong>
      <a :href="whatsappLink" target="_blank">
        <i class="fab fa-whatsapp" /></a><br>
      <span>{{ prospect.phone }}</span>
    </div>
    <div class="prospect-id column">
      <strong>ProspectId</strong><br>
      <span>{{ prospect._id }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProspectData',
  props: {
    prospect: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    whatsappLink() {
      const { name, phone } = this.prospect;
      const urlStart = 'https://api.whatsapp.com/send?phone=';
      const urlMiddle = '&text=Ol%C3%A1%20';
      return `${urlStart}${phone}${urlMiddle}${name}`;
    }
  }
};
</script>

<style scoped>

</style>
